<template>
  <div class="w-100 d-flex align-items-center">
    <div class="w-100 d-flex flex-column align-items-center">
      <validation-observer ref="observer" class="form-container login-form"
                          v-slot="{ passes }"
      >
        <b-form  @submit.prevent="passes(onSubmit)" class="d-flex flex-fill flex-column">
          <h2 class="text-center">{{resource['LoginFormTitle'] }}</h2>
          <validate-form
            id="loginUsername"
            v-model="userName"
            rules="required|min:5|email"
            type="text"
            class-group="mb-3"
            :name="resource['login.EmailFieldName']"
            :placeholder="resource['login.Username']"
            @keypress="maxLengthCheck($event, 300, 'email')"
            @keyup="maxLengthCheck($event, 300, 'email')"
          />

          <div class="position-relative">
            <validate-form
              id="loginPassword"
              v-model="password"
              rules="required|min:8"
              :type="showPassword ? 'text' : 'password'"
              class-group="mb-3 position-relative"
              :name="resource['login.Password']"
              placeholder="******"
              @keypress="maxLengthCheck($event, 20, 'password')"
              @keyup="maxLengthCheck($event, 20, 'password')"
              autocomplete
            />
            <h5
              class="show-password"
              :style="!password && 'cursor: initial'"
              @click="password && (showPassword = !showPassword)"
            >
              <img v-if="showPassword" :src="require('@/assets/images/show-password.svg')" />
              <img
                v-else
                :class="!password && 'show-password-icon'"
                :src="require('@/assets/images/hidden-password.svg')"
              />
            </h5>
          </div>

          <div class="form-group mb-3 d-flex justify-content-between align-items-center">
            <div
              :class="[
                'checkbox-2 custom-control custom-checkbox',
                'custom-control-inline d-flex align-items-center',
              ]"
            >
              <input
                id="rememberMe"
                name="rememberMe"
                v-model="rememberMe"
                type="checkbox"
                autocomplete="off"
                true-value="accepted"
                class="custom-control-input"
                value="accepted"
                unchecked-value="not_accepted"
              >
              <label for="rememberMe"
                    class="custom-control-label"
              >
                {{ resource["login.RememberMe"] }}
              </label>
            </div>
            <div
              class="btn p-0 text-hover text-color-purple bg-color-transparent forgot-password"
              id="forgotPasswordBtn"
              name="forgotPasswordBtn"
              @click="forgotPassword()"
            >
              {{ resource["login.ForgotPassword"] }}
            </div>
          </div>

          <div class="form-group footer-area"
              data-step="1"
              data-intro="Adım 1"
          >
            <div class="row">
              <div class="col-12 text-center">
                <button
                id="LoginBtn"
                name="LoginBtn"
                  type="submit"
                  :disabled="isLoading"
                  :class="[
                    'btn hover lg bg-purple',
                    'text-white w-100 justify-content-center',
                    'border-radius-50'
                  ]"
                  style="font-size: 14px !important"
                >
                  {{ resource["login.LoginText"] }}
                </button>
              </div>
            </div>
            <div class="mt-3 d-flex justify-content-center align-items-center gap-1 register-redirect-area">
              <p class="mt-0 d-flex justify-content-center"> {{ resource['hrvenue.login.dontHaveAccount'] }} </p>
              <router-link
                class="d-flex justify-content-center signup-link"
                id="registerLink"
                name="registerLink"
                :to="{
                  name: 'RegisterView',
                  params: { lang: $route.params.lang },
                }"
              >   {{ resource['hrvenue.login.requestDemo'] }} </router-link>
            </div>
            <div class="mt-3 d-flex justify-content-center align-items-center gap-1 register-redirect-area">
              <a
              class="d-flex justify-content-center signup-link"
              :href="`https://interview.co/${$route.params.lang ? `${$route.params.lang}/` : ''}login`"
              >   {{ resource['registerPage.JobSeekerLink'] }} </a>
            </div>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import CryptoJS from 'crypto-js';
import { serviceWrapper, serviceConfigs } from '@/services/configs';
import AccountService from '@/services/account';
import { handleLoader } from '@/static/helpers';
import ResourceManager from '@/services/resource.service';
import { languageItems } from '@/static/languageItems';
import hrvenueService from '../../services/hrvenue.service';

export default {
  name: 'FrmLogin',

  props: {
    returnUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      userName: '',
      password: '',
      rememberMe: false,
      forgotPasswordUrl: '/forgot-password/',
      showPassword: false,
      languageItems,
    };
  },

  created () {
  },

  mounted() {
    localStorage.removeItem('password');
    // remember me
    if (
      localStorage.getItem('userName')
      && localStorage.getItem('passwordLength')
      && localStorage.getItem('pass')
    ) {
      this.userName = localStorage.getItem('userName');
      this.rememberMe = 'accepted';
      const encryptedPassword = localStorage.getItem('pass');
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedPassword, 'secretKey');
      this.password = decryptedBytes.toString(CryptoJS.enc.Utf8);
    }
  },

  methods: {
    ...mapActions([
      'callSetResource',
    ]),
    ...mapMutations([
      'setCompanyClosingDate',
      'setCurrentUser',
      'setCompanyContract',
      'setExpressSearch',
    ]),

    setWhichInput(InpEl, value) {
      if (InpEl === 'email') {
        this.userName = value;
      } else if (InpEl === 'password') {
        this.password = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (typeof isValid !== 'undefined' && !isValid) {
        return false;
      }
      this.isLoading = true;
      const params = {
        applicationType: 1,
        username: this.userName,
        password: this.password,
        rememberMe: this.rememberMe === 'accepted',
      };

      handleLoader.showLoader();

      AccountService.deleteToken();
      serviceWrapper(
        serviceConfigs.account,
        serviceConfigs.account.login,
        params,
      )
        .then(async (response) => {
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'login',
            event_parameters: {
              method: 'email',
            },
            page_type: 'login',
            site_type: 'interview',
          });
          const { data: { body } } = response;
          if (body.token) {
            const {
              name,
              surname,
              userId,
              isFirstLogin,
              companyName,
              language,
              firstLoginKey,
            } = body;
            if (isFirstLogin === true) {
              const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

              this.$router.push({
                name: 'ResetPasswordView',
                params: { id: userId, isFirstLogin: true, lang },
                query: { p: firstLoginKey },
              });
              return false;
            }
            AccountService.setToken(body.token);
            const fullname = `${name} ${surname}`;
            AccountService.setUserInfo({
              ...this.currentUser, ...body, fullname, userId, companyName,
            });
            this.setCurrentUser({
              ...this.currentUser, ...body, fullname, userId, companyName,
            });
            const resourceLanguage = this.languageItems.find((langItem) => langItem.code === ResourceManager.CurrentLang);
            if (resourceLanguage && resourceLanguage.id !== language) {
              this.changeLanguage(resourceLanguage.id);
            }
            localStorage.setItem('ga4_user_properties', JSON.stringify({
              user_id: userId,
              user_login_status: 'yes',
            }));
            // GTM için gerekli
            // dataLayer.push({
            //   Category: 'FormGiriş',
            //   Action: 'Başarılı',
            //   Label: '',
            //   event: 'gaEvent',
            // });
            // beni hatırla
            if (this.rememberMe === 'accepted') {
              localStorage.userName = this.userName;
              const encryptedPassword = CryptoJS.AES.encrypt(this.password, 'secretKey').toString();
              localStorage.setItem('pass', encryptedPassword);
            } else {
              localStorage.removeItem('userName');
              localStorage.removeItem('passwordLength');
              localStorage.removeItem('pass');
            }

            // redirect to previous URL after login
            const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

            if (this.$route.query.redirect && this.$route.query.redirect.indexOf('undefinedlogin') <= 0) {
              this.$router.push(this.$route.query.redirect, undefined, { params: { lang } });
            } else {
              this.$router.push({
                name: 'HrVenueView',
                params: {
                  lang,
                },
              });
            }
          }
        })
        .catch(() => {
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'login_error',
            page_type: 'login',
            site_type: 'interview',
          });
        })
        .finally(() => {
          handleLoader.hideLoader();
          this.isLoading = false;
        });
    },

    forgotPassword() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'ForgotPassView', params: { lang } });
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'forgot_password_click',
        page_type: 'login',
        site_type: 'interview',
      });
    },

    async changeLanguage(languageId) {
      if (!languageId) return;
      const lang = this.languageItems.find((langItem) => langItem.id === languageId);
      await hrvenueService.setUserLanguage(lang.id);
    },
  },

  beforeDestroy() {
    ResourceManager.Get().then((res) => {
      handleLoader.showLoader();
      this.callSetResource({
        ...res,
        ...{ CurrentLang: ResourceManager.CurrentLang },
      });
      handleLoader.hideLoader();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

// .forgot-password {
// position: absolute;
// top: 5px;
// background: none;
// right: 0;
// }

.register-redirect-area {
  p {
    color: #858585;
  }
}

.footer-area {
  @include media-breakpoint-down(sm) {
    position: relative;
  }
}

.text-danger {
  color: $dark-pink;
  font-size: 12px !important;
  line-height: 18px !important;
  margin-top: 5px;
}

.custom-checkbox {
  label {
    font-size: $font-size-md;
    font-weight: $normal;
  }
}

.custom-control-input {
    &:checked {
      & ~ .custom-control-label {
        &::before {
          content: "\E925" !important;
          color: $white !important;
          background: $purple !important;
          font-size: 14px;
          text-align: center;
          position: absolute;
          left: -22px;
        }
      }
    }
  }

.forgot-password {
  font-weight: 400;
  margin-top: 5px;
}

.hover {
  &:hover {
    background: #FF8D06 !important;
  }
}

.text-hover {
  &:hover {
    color: #FF8D06 !important;
  }
}
.form-control {
  color: #353535 !important;
  &:focus {
    border-color: $dusk;
  }
}
.custom-control {
  padding-left: 21px !important;
}
.form-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  form {
      .show-password {
        position: absolute;
        color: $grey-text;
        cursor: pointer;
        top: 0;
        right: 0;
      }
    }
}

.signup-link {
  color: $purple;
  font-size: 14px !important;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
}
.login-form {
  width: 356px;
  max-width: 100%;
  background: #fff;
  border-radius: 12px;
  padding: 0 16px 16px 16px;
  z-index: 1;
  color: #333333;

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    padding-bottom: 0;
  }

  @media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {
    width: calc(100% - 32px);
  }

  h2 {
    margin-bottom: 16px !important;
    margin-top: 20px;
  }
  .forgot-password-text {
    h6 {
      font-size: 14px !important;
    }
    color: $purple;
    &:hover {
      background-color: transparent !important;
      color: #691192 !important;
      text-decoration: underline;
    }
  }
  .remember-me {
    margin: 10px 0 12px -6px !important;
    input {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.form-group {
  h6 {
    margin-top: 3px !important;
    font-weight: 700;
  }
}
.right-bottom-ad {
  min-height: 120px;
  @media screen and (max-width: 612px) {
    min-height: 100px !important;
  }
  @media screen and (max-width: 375px) {
    display: none;
  }
}
.signup-link {
    color: #FF8D06;
    font-size: 14px !important;
    text-align: center;
}
@media screen and (max-width: 1140px) {
  .header-fix {
    margin-top: 0 !important;
  }
}

.header-fix {
  margin-top: 208px;
}
@media screen and (max-height: 680px) {
  .header-fix {
    margin-top: 99px !important;
  }
}
.right-bottom-ad {
  min-height: 120px;
  display: flex;
  @media screen and (max-width: 612px) {
    min-height: 100px !important;
  }
  @media screen and (max-width: 375px) {
    display: none;
  }
}
</style>
